"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrintUtil = void 0;
const moment = require("moment-timezone");
const mobx_1 = require("mobx");
const patient_payment_balance_1 = require("shared/patient-payment-balance");
class PrintUtil {
    constructor() {
        this.convertPng = async (file) => new Promise((resolve, reject) => {
            const xhr = new XMLHttpRequest();
            xhr.responseType = "blob";
            xhr.open("GET", file);
            xhr.onload = () => {
                if (xhr.status >= 200 && xhr.status < 300)
                    resolve(xhr.responseURL);
                else
                    reject({ status: xhr.status, statusText: xhr.statusText });
            };
            xhr.send();
        });
        this.currentDate = () => {
            const today = new Date();
            const dd = today.getDate();
            const mm = today.getMonth() + 1;
            const yyyy = today.getFullYear();
            return `${mm}/${dd}/${yyyy}`;
        };
        this.currentTime = () => {
            const t = new Date(); // for now
            const hour24 = t.getHours();
            const hours = (hour24 % 12 || 12).toString().padStart(2, "0"); // D-002.90211
            const min = t.getMinutes().toString().padStart(2, "0"); // =>  30 D-002.902 _updated
            const meridian = hour24 >= 12 ? "PM" : "AM";
            return `${hours}:${min} ${meridian}`; //D-002.902 _updated
        };
        // returns day. Ex Mon, Tues, Wed, etc..
        this.currentDay = () => {
            const date = new Date();
            const dayAbbreviations = ["Sun", "Mon", "Tue", "Wed", "Thur", "Fri", "Sat"];
            return dayAbbreviations[date.getDay()];
        };
        this.mysqlDateTimeToDate = (date) => {
            const t = date.toString().split("T");
            let year = t[0];
            year = year.split("-");
            const days = year[2];
            const months = year[1];
            const years = year[0];
            return `${months}-${days}-${years}`;
        };
        //D-002.58 invoice date and time while print pdf D-002.90211
        /** Receipt PDF: zero-padded siteId-sitePay (e.g. 00012-00003). */
        this.formatPaymentNo = (siteId, sitePay) => {
            if (siteId == null || sitePay == null) {
                return "N/A";
            }
            return `${String(siteId).padStart(5, "0")}-${String(sitePay).padStart(5, "0")}`;
        };
        /** Invoice PDF: TMP + sitePay sequence (legacy system-generated payment no). */
        this.formatInvoicePaymentNo = (sitePay) => {
            if (sitePay == null) {
                return "N/A";
            }
            return `TMP${sitePay}`;
        };
        this.receiptDateTime = (date, timeZone) => {
            if (date) {
                let estMoment = moment.tz(date, 'YYYYMMDDHHmmss', 'America/New_York'); // date = 20250107082712 parse date into EST with moment;
                // D-002.90211 — site timezone, 12-hour AM/PM (not military)
                let payDateWrtSite = estMoment.clone().tz(timeZone).format('MM/DD/YYYY hh:mm:ss A');
                // let year = date.slice(0,4);
                // let month = date.slice(4,6);
                // let day = date.slice(6,8);
                // let hour = date.slice(8,10) || '00';
                // let min = date.slice(10,12) || '00';
                // let sec = date.slice(12,14) || '00';
                // return `${month}/${day}/${year} ${hour}:${min}:${sec}`;
                return payDateWrtSite;
            }
            return null;
        };
        /** D-002.840 — payment row lines for receipt/invoice PDFs (includes void/refund). */
        this.paymentTransactionPdfLines = (payment, index, site, formatPaymentNo) => {
            var _a, _b;
            const isCard = payment.method !== "Cash" && payment.method !== "Check";
            // D-002.5811 — indent detail lines under Transaction# (not the whole block)
            const detailMargin = [15, 0, 0, 0];
            const lines = [
                {
                    text: [
                        {
                            text: `Transaction#: ${index + 1}`,
                            bold: true,
                            decoration: "underline"
                        }
                    ]
                },
                { text: [{ text: "" }], margin: [0, 0, 0, 2] },
                {
                    text: [
                        { text: "Payment Type: ", bold: true },
                        { text: `${payment.method || ""}` }
                    ],
                    margin: detailMargin
                },
                {
                    text: [
                        { text: "Transaction No: ", bold: true },
                        { text: `${payment.transaction || "N/A"}` }
                    ],
                    margin: detailMargin
                },
                {
                    text: [
                        { text: "Payment No: ", bold: true },
                        { text: formatPaymentNo(payment) }
                    ],
                    margin: detailMargin
                },
                {
                    text: isCard
                        ? [
                            { text: "Authorization Code: ", bold: true },
                            { text: `${payment.authcode || "N/A"}` }
                        ]
                        : [{ text: "" }],
                    margin: detailMargin
                },
                {
                    text: [
                        {
                            text: isCard ? "Date & Time: " : "Date: ",
                            bold: true
                        },
                        {
                            text: `${(_b = this.receiptDateTime((_a = payment === null || payment === void 0 ? void 0 : payment.receipt) === null || _a === void 0 ? void 0 : _a.dateTime, site.timezone)) !== null && _b !== void 0 ? _b : moment(payment.datePaid).format("MM/DD/YYYY")}`
                        }
                    ],
                    margin: detailMargin
                },
                {
                    text: isCard
                        ? [
                            { text: "Card No: ", bold: true },
                            {
                                text: `${payment.cardEnding ? `XXXX${payment.cardEnding}` : "N/A"}`
                            }
                        ]
                        : [{ text: "" }],
                    margin: detailMargin
                },
                {
                    text: [
                        { text: "Amount Paid: ", bold: true },
                        {
                            text: `$${(((payment.amountPaid || 0) / 100) || 0).toFixed(2)}`
                        }
                    ],
                    margin: detailMargin
                }
            ];
            const refundedCents = payment.refundedAmount || 0;
            if (refundedCents > 0) {
                const reversalLabel = patient_payment_balance_1.getPaymentReversalLabel(payment) || "Reversed";
                lines.push({
                    text: [
                        { text: "Reversal: ", bold: true },
                        {
                            text: `$${(refundedCents / 100).toFixed(2)} (${reversalLabel})`,
                            color: "#616161"
                        }
                    ],
                    margin: detailMargin
                });
                if (payment.refundedAt) {
                    lines.push({
                        text: [
                            { text: "Reversal Date: ", bold: true },
                            { text: moment(payment.refundedAt).format("MM/DD/YYYY") }
                        ],
                        margin: detailMargin
                    });
                }
            }
            lines.push({ text: [{ text: "" }], margin: [0, 0, 0, 4] });
            return lines;
        };
        /** Returns Month/Day/Year */
        this.orderCreateDate = (date) => {
            const orderDate = new Date(date);
            return `${orderDate.getMonth() +
                1}/${orderDate.getDate()}/${orderDate.getFullYear()}`;
        };
        /** Parses MySQL Date field to return the time in [Hours, minutes, Time-Meridan (am/pm)] */
        this.orderCreateTime = (date) => {
            const orderDate = new Date(date);
            const hour24 = orderDate.getHours();
            const hours = hour24 % 12 || 12;
            const meridian = hour24 >= 12 ? "PM" : "AM";
            const minutes = orderDate.getMinutes();
            return `${hours}:${minutes} ${meridian}`;
        };
        this.parseMonograph = (monograph) => {
            const filteredAttr = [
                "adverse_reactions_table",
                "clinical_studies_table",
                "dosage_and_administration_table",
                "how_supplied_table",
                "id",
                "openfda",
                "set_id",
                "spl_product_data_elements",
                "version",
                "warnings_table"
            ];
            try {
                const hasData = Object.keys(monograph).length !== 0;
                let result = {};
                result = monograph.results[0];
                const stack = Object.keys(result)
                    .filter((e) => !filteredAttr.includes(e) && !e.includes("table"))
                    .map((e, index) => {
                    const text = Array.isArray(result[e])
                        ? result[e].join(" ")
                        : result[e];
                    let textStr = text.toString();
                    let attr = e.split("_").join(" ");
                    const noTitle = textStr.search(new RegExp(attr, "i")) === -1;
                    if (attr === "effective time") {
                        textStr = moment(textStr).format("MM/DD/YYYY");
                    }
                    else {
                        textStr = textStr.replace(/^\d+\.*\d*\s*/, "");
                    }
                    if (noTitle) {
                        attr = `${attr.toUpperCase()}: `;
                        textStr = attr.concat(textStr);
                    }
                    return textStr.replace("Section Text", "");
                })
                    .map(value => ({
                    text: value,
                    margin: [0, 10, 10, 0],
                    fontSize: 8
                }));
                const hasDataGeneric = hasData ? mobx_1.toJS(result.openfda.generic_name) : "";
                const hasDataCommonBrand = hasData
                    ? `COMMON BRAND NAME(S): ${result.openfda.brand_name}`
                    : "";
                return {
                    defaultImportantText: "IMPORTANT: HOW TO USE THIS INFORMATION: This is a summary and does NOT have all possible information about this product. This information does not assure that this product is safe, effective, or appropriate for you. This information is not individual medical advice and does not substitute for the advice of your health care professional. Always ask your health care professional for complete information about this product and your specific health needs.",
                    hasDataGeneric,
                    hasDataCommonBrand,
                    stack
                };
            }
            catch (error) {
                return {
                    defaultImportantText: "Additional Medication information can be provided by your medical provider."
                };
            }
        };
    }
}
exports.PrintUtil = PrintUtil;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/labels/print-labels/print-manager/print-util.ts
// module id = 147
// module chunks = 0 1